export default __webpack_public_path__ + "static/media/section3_3.5c4a8ff0.png";